/**
 * Module definition houses all application content resources
 *
 * @module content
 */
angular.module('content', [
  'content.widgets',
  'content.ContentController'
])

/**
 * The content provides a view listing all content
 *
 * @class content
 * @constructor
 * @module content
 * @example
 *   <content
 *     model="form.model">
 *   </content>
 */
.directive('content', [
  function () {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: function () {
        return 'content/source/content/content.html';
      },
      controller: 'ContentController'
    };
  }
]);
